import ISOCountriesRULocale from 'i18n-iso-countries/langs/ru.json';
import ISOCountries from 'i18n-iso-countries';

ISOCountries.registerLocale(ISOCountriesRULocale);

export { ISOCountries };
